import { GenericObject, copyFields, fixDates } from '@synergy/models';

import { ProductSnapshot } from './product-snapshot';
import { User } from './user';

export class OfferItem extends ProductSnapshot {
    public id?: number;
    public isOffered!: boolean;
    public isAlternative!: boolean;
    public isSelected?: boolean;
    public alternativeNote?: string;
    public purchaseItem?: { id: number };
    public createdAt?: Date;
    public createdBy?: User;
    public updatedAt?: Date;
    public updatedBy?: User;

    public static fromPlainObject(object: GenericObject): OfferItem {
        const offerItem = new OfferItem();

        // Import own keys
        copyFields(object, offerItem);

        // Import from base class (ProductSnapshot)
        const productSnapshot = ProductSnapshot.fromPlainObject(object);

        // Overwrite own keys with base keys
        copyFields(productSnapshot, offerItem);

        if (object['createdBy']) {
            offerItem.createdBy = User.fromPlainObject(object['createdBy']);
        }

        if (object['updatedBy']) {
            offerItem.updatedBy = User.fromPlainObject(object['updatedBy']);
        }

        fixDates(offerItem, ['createdAt', 'updatedAt']);

        return offerItem;
    }
}
